import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
	selector: "app-constants",
	templateUrl: "./constants.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConstantsComponent { }
